import {
    FETCH_YARN_MASTER_REQUEST,
    FETCH_YARN_MASTER_SUCCESS,
    FETCH_YARN_MASTER_FAILURE,
    CREATE_YARN_MASTER_FORM,
    UPDATE_YARN_MASTER_FORM,
    CREATE_YARN_MASTER_SUCCESS,
    FETCH_SINGLE_YARN_MASTER_SUCCESS,
    UPDATE_YARN_MASTER_SUCCESS,
    DELETE_YARN_MASTER_SUCCESS,
    CREATE_YARN_MASTER_REQUEST,
    UPDATE_YARN_MASTER_REQUEST,
    FETCH_SINGLE_YARN_MASTER_REQUEST,
    DELETE_YARN_MASTER_REQUEST,
    RESET_YARN_MASTER_INFO,
    CREATE_YARN_MASTER_FAILURE,
    UPDATE_YARN_MASTER_FAILURE,
    FETCH_SINGLE_YARN_MASTER_FAILURE,
    DELETE_YARN_MASTER_FAILURE,
    FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST,
    FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS,
    FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE,
    FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST,
    FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS,
    FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE,
    FETCH_YARN_MATERIALS_REQUEST,
    FETCH_YARN_MATERIALS_SUCCESS,
    FETCH_YARN_MATERIALS_FAILURE
} from './yarnMaster.actionsType';

export const YARN_MASTER = 'yarnMaster';

let initialState = {
    loading: false,
    yarnMasterList: [],
    yarnMasterGroupDistinctList: [],
    yarnMasterTypeDistinctList: [],
    yarnMasterForm: {},
    selectedState: {},
    yarnMaterial: [],
    errorMessage: ''
};

export let yarnMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_YARN_MASTER_REQUEST:
        case FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST:
        case FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST:
        case CREATE_YARN_MASTER_REQUEST:
        case UPDATE_YARN_MASTER_REQUEST:
        case FETCH_SINGLE_YARN_MASTER_REQUEST:
        case DELETE_YARN_MASTER_REQUEST:
        case FETCH_YARN_MATERIALS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterList: updatePayload
            };
        case FETCH_YARN_MATERIALS_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMaterial: updatePayload
            };
        case FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterGroupDistinctList: updatePayload
            };
        case FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterTypeDistinctList: updatePayload
            };
        case CREATE_YARN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterForm: {}
            };
        case UPDATE_YARN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterForm: {}
            };
        case FETCH_SINGLE_YARN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterForm: updatePayload
            };
        case DELETE_YARN_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yarnMasterForm: {}
            };
        case RESET_YARN_MASTER_INFO:
            return {
                ...state,
                yarnMasterForm: {}
            };
        case CREATE_YARN_MASTER_FORM:
        case UPDATE_YARN_MASTER_FORM:
            return {
                ...state,
                loading: false,
                yarnMasterForm: {
                    ...state.yarnMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_YARN_MASTER_FAILURE:
        case FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE:
        case FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE:
        case CREATE_YARN_MASTER_FAILURE:
        case UPDATE_YARN_MASTER_FAILURE:
        case FETCH_SINGLE_YARN_MASTER_FAILURE:
        case DELETE_YARN_MASTER_FAILURE:
        case FETCH_YARN_MATERIALS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
